<template>
  <b-modal
    :visible="visible"
    centered
    hide-header
    hide-footer
    scrollable
    dialog-class="modal-color-black file-preview-dialog"
    @hide="onDialogClose"
  >
    <div class="file-preview-header">
      <h3 class="file-preview-header-text">{{ $t('File preview') }}</h3>
    </div>

    <div class="file-preview-content">
      <s3-file-image
        show-loading
        :s3-key="s3Key"
        :alt="$t('File preview')"
        :error-text="$t('Failed to load file preview')"
        :not-image-text="$t('File is not an image: unable to display preview')"
      />
    </div>

    <div class="file-preview-actions">
      <b-button pill size="sm" variant="primary" class="text-uppercase mx-2" @click="onDialogClose">
        <span>{{ $t('Close') }}</span>
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import S3FileImage from '@/components/common/S3FileImage';

export default {
  name: 'FilePreviewDialog',

  components: { S3FileImage },

  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    s3Key: {
      type: String,
      default: null,
    },
  },

  methods: {
    onDialogClose() {
      this.$emit('close');
    },
  },
};
</script>

<style>
.file-preview-dialog {
  min-width: 768px;
}

.file-preview-dialog .modal-body {
  padding: 32px 52px;
}
</style>

<style scoped>
.file-preview-header {
  border-bottom: 2px solid var(--bs-gray-500);
}

.file-preview-header-text {
  font-weight: 700;
}

.file-preview-content {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px;
}

.file-preview-actions {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 32px;
}
</style>



// WEBPACK FOOTER //
// src/components/organisation/FilePreviewDialog.vue